import http from '@/http/http'
import apiCfg from "../../config"
export default{

    // 查询柜子里面的尾程订单
    contOrdertailById(params) {
        return http.get(apiCfg.managerApi+"/order/tail/orderTail", params)
    },
    //查询尾程订单内贴标详情信息
    conttaildetailList(params) {
        return http.get(apiCfg.managerApi+ "/order/tail/detail/tailDetailList", params)
    },
   
}